import wixAnimations from 'wix-animations';
import { getBoundingRect } from 'wix-window';
import { local } from 'wix-storage';
import { fireBIEvent } from 'public/bi-events.js';

$w.onReady(function () {
    fireBiEventOnElements();
    banner();
});

function banner() {

    let bannerBox = $w('#bannerBox');

    let move = 1455;

    let bannerTimeline = wixAnimations.timeline({ repeat: -1 }).add(bannerBox, { x: move, duration: 10000, easing: 'easeLinear' })

    bannerTimeline.play();

    bannerBox.onMouseIn(() => {
        bannerTimeline.pause();
    });

    bannerBox.onMouseOut(() => {
        bannerTimeline.play();
    })

}

const fireBiEventOnElements = () => {
    const currentSection = local.getItem('currentSection');

    $w('#box1241').onClick(() => {
        const biFields = {
            tab_name: currentSection,
            cta_loc: 'down'
        }
        fireBIEvent(110, 2401, biFields);
    });
    $w('#box1241').onViewportEnter(() => {

        const biFields = {
            tab_name: currentSection,
        }
        const isEndOfThePage = local.getItem('isEndOfThePage') === 'true';
        local.setItem('isEndOfThePage', 'true');
        !isEndOfThePage && fireBIEvent(110, 2406, biFields);
    })
}